import {CONFIG} from '../lib/config';
import {getOcrDeviceSecret} from '../lib/ocrDevice';

let identity: Promise<void> | undefined;

async function ensureIdentity(): Promise<void> {
  if (!identity) {
    identity = getOcrDeviceSecret().then(async deviceSecret => {
      const response = await fetch(`${CONFIG.ocrBackendUrl}/ocr/identity`, {
        method: 'POST', credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({device_secret: deviceSecret}),
      });
      if (!response.ok) throw new Error('Не вдалося підтвердити OCR-сесію. Спробуйте оновити сторінку.');
    }).catch(error => {
      identity = undefined;
      throw error;
    });
  }
  await identity;
}

export async function ocrFetch(input: string, init?: RequestInit): Promise<Response> {
  await ensureIdentity();
  const response = await fetch(input, {...init, credentials: 'include'});
  if (response.status !== 401) return response;
  // A 401 is rejected before the body/inference runs. Renew once, never retry
  // network failures or server errors that may have completed a mutation.
  identity = undefined;
  await ensureIdentity();
  return fetch(input, {...init, credentials: 'include'});
}
